<div class="flex flex-col bg-[var(--colorGrey)] mt-8 mb-8 p-4 rounded text-[var(--color-text-strong)]">
    <div class="flex flex-col">
        <p class="font-bold text-sm">{{ title() }}</p>
        <p class="text-[rgb(var(--ui-5))] mt-2 text-sm">{{ subtitle() }}</p>
        <h1 class="text-l font-bold mt-4 mb-4">{{ totalBudget() | customCurrency }}</h1>
    </div>

    <div>
        <p class="mb-2 font-bold text-sm">
            {{ 'seasons.season-details.setting-cards.budget-card.employee' | translate }}
        </p>
        <div class="flex flex-row text-sm">
            <div class="flex flex-col">
                <p class="text-[rgb(var(--ui-5))]">
                    {{ 'seasons.season-details.setting-cards.budget-card.first-subsidy' | translate }}
                </p>
                <p>{{ employeeSubsidies?.[0]?.amount ?? null | customCurrency }}</p>
            </div>
            <div class="flex flex-col ml-32">
                <p class="text-[rgb(var(--ui-5))]">
                    {{ 'seasons.season-details.setting-cards.budget-card.second-subsidy' | translate }}
                </p>
                <p>{{ employeeSubsidies?.[1]?.amount ?? null | customCurrency }}</p>
            </div>
        </div>
    </div>

    <div class="mt-2 mb-2 h-px bg-[rgb(var(--ui-6))]" aria-hidden="true"></div>

    <div>
        <p class="mb-2 font-bold text-sm">
            {{ 'seasons.season-details.setting-cards.budget-card.spouse' | translate }}
        </p>
        <div class="flex flex-row text-sm">
            <div class="flex flex-col">
                <p class="text-[rgb(var(--ui-5))]">
                    {{ 'seasons.season-details.setting-cards.budget-card.first-subsidy' | translate }}
                </p>
                <p>{{ spouseSubsidies?.[0]?.amount ?? null | customCurrency }}</p>
            </div>
            <div class="flex flex-col ml-32">
                <p class="text-[rgb(var(--ui-5))]">
                    {{ 'seasons.season-details.setting-cards.budget-card.second-subsidy' | translate }}
                </p>
                <p>{{ spouseSubsidies?.[1]?.amount ?? null | customCurrency }}</p>
            </div>
        </div>
    </div>

    <div class="mt-2 mb-2 h-px bg-[rgb(var(--ui-6))]" aria-hidden="true"></div>

    <div>
        <p class="mb-2 font-bold text-sm">
            {{ 'seasons.season-details.setting-cards.budget-card.children' | translate }}
        </p>
        <div class="flex flex-row text-sm">
            <div class="flex flex-col">
                <p class="text-[rgb(var(--ui-5))]">
                    {{ 'seasons.season-details.setting-cards.budget-card.first-subsidy' | translate }}
                </p>
                <p>{{ childSubsidies?.[0]?.amount ?? null | customCurrency }}</p>
            </div>
            <div class="flex flex-col ml-32">
                <p class="text-[rgb(var(--ui-5))]">
                    {{ 'seasons.season-details.setting-cards.budget-card.second-subsidy' | translate }}
                </p>
                <p>{{ childSubsidies?.[1]?.amount ?? null | customCurrency }}</p>
            </div>
        </div>
    </div>
</div>
